import { useMemo } from 'react';
import HomeTrending from "@pages/Home/sections/HomeTrending/HomeTrending";
import HomePlaces from "@pages/Home/sections/HomePlaces/HomePlaces";
import HomeRecentSearches from '@pages/Home/sections/HomeRecentSearches/HomeRecentSearches';
import HomeReportsAndNews from "@pages/Home/sections/HomeReportsAndNews/HomeReportsAndNews";
import HomeCategoryLens from "@pages/Home/sections/HomeCategoryLens/HomeCategoryLens";
import HomeFoodsMenuGrowth from "@pages/Home/sections/HomeFoods/HomeFoodsMenuGrowth";
import HomeSectionDelimiter from "@pages/Home/components/HomeSectionDelimiter";
import HomeWorkspaceLayout from "@pages/Home/components/HomeWorkspaceLayout";

export const HOME_PAGE_SCROLLBAR_ID = 'HomePageScrollbar';

const ManufacturersWorkspace = () => {
    const sections = useMemo(
        () => [
            {
                id: 'news-reports',
                title: 'News & Reports',
                testId: 'blockHomeReports',
                Component: HomeReportsAndNews
            },
            {
                id: 'trending-now',
                title: "Trending Now",
                testId: 'blockHomeTrendingNow',
                Component: () => <HomeTrending showShortTable showTopPosts />
            },
            {
                id: 'category-lens',
                title: 'Category Lens',
                testId: 'blockHomeCategoryLens',
                Component: () => (
                    <HomeCategoryLens
                        nextSectionId="places"
                        extraContent={
                            <div className="Home__sub-wrapper">
                                <HomeSectionDelimiter colors={[]} noLogo/>
                                <HomeFoodsMenuGrowth/>
                            </div>
                        }
                    />
                ),
            },
            { id: 'places', title: 'Places', testId: 'blockHomePlaces', Component: HomePlaces },
            {
                id: 'recent-searches',
                title: 'Recent Searches',
                testId: 'blockHomeRecentSearches',
                Component: HomeRecentSearches
            },
        ],
        []
    );

    return (
        <HomeWorkspaceLayout
            scrollbarId={HOME_PAGE_SCROLLBAR_ID}
            sections={sections}
        />
    );
};

export default ManufacturersWorkspace;
